import type {Poster} from '@PosterWhiteboard/poster/poster.class';
import debounce from 'lodash/debounce';
import {generatePosterPreview, generatePosterPreviewWithBeacon} from '@Libraries/poster-library';

const DEBOUNCE_GENERATE_PREVIEW_DEFAULT_WAIT = 240000;

export class PosterPreview {
  private readonly poster: Poster;
  private readonly debouncedGeneratePreview;
  private readonly boundHandleVisibilityChange = this.handleVisibilityChange.bind(this);

  constructor(poster: Poster) {
    this.poster = poster;
    this.debouncedGeneratePreview = debounce(() => {
      this.generatePreview();
    }, DEBOUNCE_GENERATE_PREVIEW_DEFAULT_WAIT);

    window.addEventListener('visibilitychange', this.boundHandleVisibilityChange);
  }

  private handleVisibilityChange(): void {
    if (document.visibilityState === 'hidden') {
      this.generatePreviewWithBeacon();
    }
  }

  public onDispose(): void {
    window.removeEventListener('visibilitychange', this.boundHandleVisibilityChange);
  }

  public triggerDebouncedGeneratePreview(): void {
    this.debouncedGeneratePreview();
  }

  private generatePreview(): void {
    if (!this.poster.mode.isGeneration()) {
      void generatePosterPreview(this.poster.hashedID).catch((e: unknown) => {
        console.error(e);
      });
    }
  }

  private generatePreviewWithBeacon(): void {
    if (!this.poster.mode.isGeneration()) {
      generatePosterPreviewWithBeacon(this.poster.hashedID);
    }
  }
}
